import React, { useMemo } from 'react';
import cx from 'classnames';
import { getColumnsGroupByCustomHeader, getFirstColumnMinWidth } from './ResponsiveTableHelper';
import HeaderCell from './HeaderCell';
var FIRST_COLUMN_INDEX = 0;
var ResponsiveTableHeader = function (_a) {
    var _b;
    var visibleColumns = _a.visibleColumns, firstColActualWidth = _a.firstColActualWidth, firstColumnMinWidth = _a.firstColumnMinWidth, rowMinWidth = _a.rowMinWidth, headerScrollRef = _a.headerScrollRef, hasScrollLeft = _a.hasScrollLeft, customHeaders = _a.customHeaders, tableProps = _a.tableProps, sortField = _a.sortField, sortDirection = _a.sortDirection, onHeaderClick = _a.onHeaderClick;
    var hasCustomHeader = customHeaders && customHeaders.length > 0;
    var columnsGroupByCustomHeader = useMemo(function () {
        if (customHeaders) {
            return getColumnsGroupByCustomHeader(visibleColumns, customHeaders);
        }
        return {};
    }, [visibleColumns, customHeaders]);
    var sharedHeaderCellProps = {
        sortField: sortField,
        sortDirection: sortDirection,
        hasScrollLeft: hasScrollLeft,
        onHeaderClick: onHeaderClick,
        headerIconPosition: tableProps.headerIconPosition,
        tableId: tableProps.tableId
    };
    return (<div className="c-responsive-table-header-outer">
      {/* Fixed non-scrolling first column */}
      <div className="c-responsive-table-first-col-header" style={{ width: firstColActualWidth, minWidth: firstColumnMinWidth }}>
        <table style={{ width: firstColActualWidth }}>
          <colgroup>
            <col style={{ width: firstColActualWidth }}/>
          </colgroup>
          <thead className="c-responsive-table-header">
            {hasCustomHeader && (<tr className="c-responsive-table-custom-header-row" aria-hidden="true">
                <th className={cx('c-responsive-table-custom-header-wrapper', 'c-responsive-table-custom-header-wrapper--remove-border', 'c-responsive-table-custom-header-wrapper--placeholder')}/>
              </tr>)}
            <tr className="c-responsive-table-header-row">
              <HeaderCell {...sharedHeaderCellProps} column={visibleColumns[FIRST_COLUMN_INDEX]} idx={FIRST_COLUMN_INDEX}/>
            </tr>
            {tableProps.customSecondHeaderRender && (<tr className="c-responsive-table-second-header-row">
                <th scope="col" style={{ visibility: tableProps.customFirstColSecondHeaderRender ? 'visible' : 'hidden' }}>
                  <span aria-hidden={!tableProps.customFirstColSecondHeaderRender}>{(_b = tableProps.customFirstColSecondHeaderRender) === null || _b === void 0 ? void 0 : _b.call(tableProps)}</span>
                </th>
              </tr>)}
          </thead>
        </table>
      </div>

      {/* Scrollable columns 2-N — scrollbar starts right after the sticky first column */}
      <div ref={headerScrollRef} className="c-responsive-table-header-inner">
        <table style={{ minWidth: rowMinWidth - firstColumnMinWidth }}>
          <colgroup>
            {visibleColumns.slice(1).map(function (column) {
            var _a;
            var pct = (getFirstColumnMinWidth(column) / (rowMinWidth - firstColumnMinWidth)) * 100;
            return <col key={String((_a = column.field) !== null && _a !== void 0 ? _a : column.cssModifier)} style={{ width: "".concat(pct, "%") }}/>;
        })}
          </colgroup>
          <thead className="c-responsive-table-header">
            {hasCustomHeader && (<tr className="c-responsive-table-custom-header-row">
                {Object.entries(columnsGroupByCustomHeader).map(function (_a, index, array) {
                var key = _a[0], value = _a[1];
                var isEmptyCustomHeader = value.title === '';
                var previousValue = index > 0 ? array[index - 1][1] : null;
                var isPreviousCustomHeaderNotEmpty = previousValue && previousValue.title !== '';
                return (<th key={key} colSpan={value.columns.length} scope="colgroup" className={cx('c-responsive-table-custom-header-wrapper', {
                        'c-responsive-table-custom-header-wrapper--remove-border': isEmptyCustomHeader,
                        'c-responsive-table-custom-header-wrapper--remove-border--left': isPreviousCustomHeaderNotEmpty
                    })}>
                      {!isEmptyCustomHeader && <div className="c-responsive-table-custom-header">{value.title}</div>}
                    </th>);
            })}
              </tr>)}
            <tr className="c-responsive-table-header-row">
              {visibleColumns.slice(1).map(function (column, idx) {
            var _a;
            return (<HeaderCell key={String((_a = column.field) !== null && _a !== void 0 ? _a : column.cssModifier)} {...sharedHeaderCellProps} column={column} idx={idx + 1}/>);
        })}
            </tr>
            {tableProps.customSecondHeaderRender && (<tr className="c-responsive-table-second-header-row">
                <th scope="colgroup" colSpan={visibleColumns.length - 1}>
                  {tableProps.customSecondHeaderRender()}
                </th>
              </tr>)}
          </thead>
        </table>
      </div>
    </div>);
};
export default ResponsiveTableHeader;
